


















import Vue from 'vue';
import Component from 'vue-class-component';
import Plyr from 'plyr';
import { Prop } from 'vue-property-decorator';
import { PoiAudio } from '@/models/poi';
import { urlize } from '@/utils';

@Component
export default class PoiSlideAudio extends Vue {

    @Prop(Object) public model: PoiAudio;
    @Prop({ type: Boolean, default: true }) public enabled: boolean;

    public isPlaying = false;
    private audioTrack: HTMLAudioElement;
    private player: Plyr;

    get audioUrl() {
        return urlize(this.model.audio);
    }

    get imageUrl() {
        return urlize(this.model.image.medium);
    }

    public onPlayClicked() {
        this.isPlaying = true;

        this.$nextTick(() => {
            this.audioTrack = this.$refs.audioTrack as HTMLAudioElement;
            this.player = new Plyr(this.audioTrack, {
                controls: ['play', 'progress', 'current-time'],
                tooltips: { controls: false, seek: false },
                invertTime: false
            });

            this.audioTrack.play();
        });
    }

    public onSlideChanged() {
        if (this.audioTrack) {
            this.audioTrack.pause();
        }
    }

}
